"use client"

import { useMutation, useQueryClient } from "@tanstack/react-query"
import { useState } from "react"
import {
  streamRequestGeneration,
  type StreamGenerateParams,
} from "../../lib/stream-request-generation"
import { queryKeys } from "@/shared/lib/query-keys"

export type GenerationProgressState = {
  label: string
  percent: number
  detail?: string
}

export function useGenerateImage() {
  const queryClient = useQueryClient()
  const [generationProgress, setGenerationProgress] = useState<GenerationProgressState | null>(
    null
  )

  const mutation = useMutation({
    onMutate: () => {
      setGenerationProgress({ label: "Starting…", percent: 1 })
    },
    mutationFn: (params: StreamGenerateParams) =>
      streamRequestGeneration(params, (ev) => {
        if (ev.type === "progress") {
          setGenerationProgress({
            label: ev.label,
            percent: ev.percent,
            detail: ev.detail,
          })
        }
      }),
    onSettled: () => {
      setGenerationProgress(null)
    },
    onSuccess: () => {
      // Refetch on success and on handled errors (e.g. TOS) so failed rows show server error_message.
      queryClient.invalidateQueries({ queryKey: queryKeys.generations.all() })
    },
  })

  return { ...mutation, generationProgress }
}
